import { render, staticRenderFns } from "./NotificationSubject.vue?vue&type=template&id=36dc375e&scoped=true"
import script from "./NotificationSubject.vue?vue&type=script&lang=js"
export * from "./NotificationSubject.vue?vue&type=script&lang=js"
import style0 from "./NotificationSubject.vue?vue&type=style&index=0&id=36dc375e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc375e",
  null
  
)

export default component.exports